"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _helpers = require("../../helpers");
var _ResourceSelector = _interopRequireDefault(require("../ResourceSelector.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Certificate = function Certificate(_ref) {
  var certificates = _ref.certificates,
    deleteCertificate = _ref.deleteCertificate,
    index = _ref.index,
    name = _ref.name;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    firstLoad = _useState2[0],
    setFirstLoad = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showEditors = _useState4[0],
    setShowEditors = _useState4[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (firstLoad) {
      setFirstLoad(false);
    } else {
      // We must briefly remove the TinyMCE editors to allow the content to change
      setShowEditors(false);
      // Render the TinyMCE editors again in a short time
      setTimeout(function () {
        return setShowEditors(true);
      }, 50);
    }
  }, [certificates.length]);

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var deleteCertificateButton = !certificates || certificates.length < 2 ? null : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Certificate"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-xs btn-danger ".concat(_style["default"].deleteButton),
    onClick: deleteCertificate
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  var headerInfo = !certificates || certificates.length < 2 ? null : /*#__PURE__*/_react["default"].createElement("h4", null, "Certificate ", index + 1);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].certificateContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerInfo
  }, headerInfo, deleteCertificateButton), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdInput,
    label: "Course Name",
    name: "".concat(name, ".courseName")
  }), showEditors && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Free Text",
      tooltip: "Appears below Course Name. E.g., '3.5 Hours of C.E. Credit'."
    }),
    name: "".concat(name, ".freeText"),
    type: "input"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _ResourceSelector["default"],
    label: "Certificate Image",
    name: "".concat(name, ".backgroundId")
  }), showEditors && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 1",
    name: "".concat(name, ".accreditation1"),
    type: "textarea"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 2",
    name: "".concat(name, ".accreditation2"),
    type: "textarea"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 3",
    name: "".concat(name, ".accreditation3"),
    type: "textarea"
  })));
};
Certificate.propTypes = {
  certificates: _propTypes["default"].array,
  deleteCertificate: _propTypes["default"].func,
  index: _propTypes["default"].number,
  name: _propTypes["default"].string
};
var _default = Certificate;
exports["default"] = _default;